import { RackCellMap } from "../rack-cell-mapping.entity";
import { RackCellMapDTO } from "./rack-cell-mapping.dto";

export class RackCellMapAdapter {
    convertDtoToEntity(dtoObj: RackCellMapDTO,  isUpdate: boolean = false ): RackCellMap {
        try {
            const entityObj = new RackCellMap();
            entityObj.createdUser = dtoObj.createdUser;
            entityObj.rackId = dtoObj.rackId;
            entityObj.cellId = dtoObj.cellId;
            entityObj.levelId = dtoObj.levelId;
            entityObj.zoneId = dtoObj.zoneId;
            if (dtoObj.rackCellMapId) {
                entityObj.rackCellMapId = dtoObj.rackCellMapId;
                entityObj.updatedUser = dtoObj.updatedUser;
            }
            entityObj.isActive = dtoObj.isActive;
            return entityObj;
        } catch (Error) {
            throw Error;
        }
    }

    public convertEntityToDto(rackCellMapObject: RackCellMap): RackCellMapDTO {
        const rackCellMapDTO= new RackCellMapDTO;
        rackCellMapDTO.rackCellMapId = rackCellMapObject.rackCellMapId;
        rackCellMapDTO.rackId = rackCellMapObject.rackId;
        rackCellMapDTO.cellId = rackCellMapObject.cellId;
        rackCellMapDTO.zoneId = rackCellMapObject.zoneId;
        rackCellMapDTO.levelId = rackCellMapObject.levelId;
        rackCellMapDTO.isActive = rackCellMapObject.isActive;
        rackCellMapDTO.createdAt = rackCellMapObject.createdAt;
        rackCellMapDTO.updatedAt = rackCellMapObject.updatedAt;
        rackCellMapDTO.createdUser = rackCellMapObject.createdUser;
        rackCellMapDTO.updatedUser = rackCellMapObject.updatedUser;
        rackCellMapDTO.versionFlag = rackCellMapObject.versionFlag;
        return rackCellMapDTO;
      }
}